import { useEffect } from 'react';

/**
 * Sets document.title and (optionally) <meta name="description"> for the
 * current page. Restores the previous values on unmount.
 *
 * Usage:
 *   useDocumentTitle('Ted AI — Ultimate Pet Foods', 'Upload any dog food bag and Ted AI tells you what is really in it.');
 */
export function useDocumentTitle(title, description) {
  useEffect(() => {
    const previousTitle = document.title;
    if (title) {
      document.title = title;
    }

    let metaEl = null;
    let previousDescription = null;
    if (description) {
      metaEl = document.querySelector('meta[name="description"]');
      if (metaEl) {
        previousDescription = metaEl.getAttribute('content');
        metaEl.setAttribute('content', description);
      }
    }

    return () => {
      document.title = previousTitle;
      if (metaEl && previousDescription !== null) {
        metaEl.setAttribute('content', previousDescription);
      }
    };
  }, [title, description]);
}
